import React, { useState, useEffect, useRef } from "react";
import "../stylesheet/forms.css";
import Topnav from "../components/others/Topnav";
import totalPatients from "../images/totalPatients.svg";
import revenueIcon from "../images/revenue.svg";
import expensesIcon from "../images/expenses.svg";
import stockIcon from "../images/stock.svg";
import lineIcon from "../images/line-icon.svg";
import rightArrow from "../images/right-arrow.svg";
import { Doughnut, Line, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Filler,
} from "chart.js";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { faker } from "@faker-js/faker";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Filler
);

const Dashboard = () => {
  const [appointmentData, setAppointmentData] = useState([
    {
      id: 1,
      name: "Tayo Peters",
      apptNo: "#430683682",
      date: "Fri mar 15, 2;00pm GMT",
      apptType: "In person",
      status: "Pending",
      isOpen: false,
    },
    {
      id: 2,
      name: "Tayo Peters",
      apptNo: "#430683682",
      date: "Fri mar 15, 2;00pm GMT",
      apptType: "In person",
      status: "Pending",
      isOpen: false,
    },
    {
      id: 3,
      name: "Tayo Peters",
      apptNo: "#430683682",
      date: "Fri mar 15, 2;00pm GMT",
      apptType: "In person",
      status: "Completed",
      isOpen: false,
    },
  ]);

  const dropdownRef = useRef(null);

  const toggleDropdown = (itemId) => {
    setAppointmentData((prevReport) =>
      prevReport.map((item) => {
        if (item.id === itemId) {
          return {
            ...item,
            isOpen: !item.isOpen,
          };
        }
        return {
          ...item,
          isOpen: false, // Close dropdown for other items
        };
      })
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAppointmentData((prevReport) =>
          prevReport.map((item) => ({
            ...item,
            isOpen: false,
          }))
        );
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const doughnutData = {
    labels: [],
    datasets: [
      {
        label: "# of Patients",
        data: [50, 5, 15],
        backgroundColor: ["#049561", "#9FF1CA", "#AF290B"],
      },
    ],
  };

  const areaOptions = {
    responsive: true,
    tension: 0.3,
  };

  const barOptions = {
    responsive: true,
    interaction: {
      intersect: false,
    },
    scales: {
      y: {
        stacked: true,
      },
      x: {
        stacked: true,
      },
    },
  };

  const areaLabels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
  ];

  const barLabels = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

  const areaData = {
    labels: areaLabels,
    datasets: [
      {
        fill: true,
        label: "Expenses",
        data: areaLabels.map(() => faker.number.int({ min: 220, max: 500 })),
        backgroundColor: "rgba(255, 9, 9, 0.32)",
      },
      {
        fill: true,
        label: "Income",
        data: areaLabels.map(() => faker.number.int({ min: 110, max: 350 })),
        backgroundColor: "rgba(4, 149, 97, 0.48)",
      },
    ],
  };

  const barData = {
    labels: barLabels,
    datasets: [
      {
        data: barLabels.map(() => faker.number.int({ min: -40, max: 0 })),
        backgroundColor: "#4F4F4F",
        stack: "Stack 0",
        borderRadius: 5,
        barPercentage: 2,
        barThickness: 9,
      },
      {
        data: barLabels.map(() => faker.number.int({ min: 0, max: 100 })),
        backgroundColor: "#009FE3",
        stack: "Stack 0",
        borderRadius: 5,
        barPercentage: 1,
        barThickness: 9,
      },
    ],
  };

  return (
    <>
      <Topnav />
      <div className="font-euclid-circular-a dashboard overflow-auto mb-10">
        <div>
          {/* totals section */}
          <div className="flex justify-around mt-4 font-euclid-circular-a">
            <div className="flex p-2">
              <div>
                <img src={totalPatients} alt="patients icon" className="ml-3" />
                <p className="mt-6 ml-2 text-sky-500 text-base font-semibold font-['Euclid Circular A'] underline leading-none cursor-pointer">
                  Show details
                </p>
              </div>
              <div>
                <p className="text-neutral-600 text-lg font-bold leading-none">
                  Total Patients
                </p>
                <p className="mt-2 text-neutral-900 text-2xl font-bold leading-none">
                  120
                </p>
              </div>
            </div>

            <div className="flex p-2">
              <div>
                <img src={revenueIcon} alt="patients icon" className="ml-3" />
                <p className="mt-6 ml-2 text-sky-500 text-base font-semibold font-['Euclid Circular A'] underline leading-none cursor-pointer">
                  Show details
                </p>
              </div>
              <div>
                <p className="text-neutral-600 text-lg font-bold leading-none">
                  Total Revenue
                </p>
                <p className="mt-2 text-neutral-900 text-2xl font-bold leading-none">
                  1,456
                </p>
              </div>
            </div>

            <div className="flex p-2">
              <div>
                <img src={expensesIcon} alt="patients icon" className="ml-3" />
                <p className="mt-6 ml-2 text-sky-500 text-base font-semibold font-['Euclid Circular A'] underline leading-none cursor-pointer">
                  Show details
                </p>
              </div>
              <div>
                <p className="text-neutral-600 text-lg font-bold leading-none">
                  Total Expenses
                </p>
                <p className="mt-2 text-neutral-900 text-2xl font-bold leading-none">
                  &#8358; 264,783
                </p>
              </div>
            </div>

            <div className="flex p-2">
              <div>
                <img src={stockIcon} alt="patients icon" className="ml-3" />
                <p className="mt-6 ml-2 text-sky-500 text-base font-semibold font-['Euclid Circular A'] underline leading-none cursor-pointer">
                  Show details
                </p>
              </div>
              <div>
                <p className="text-neutral-600 text-lg font-bold leading-none">
                  Out Of Stock
                </p>
                <p className="mt-2 text-neutral-900 text-2xl font-bold leading-none">
                  35
                </p>
              </div>
            </div>
          </div>

          {/* patients summary and revenue */}
          <div className="flex gap-4 mt-8 ml-4">
            <div className="w-[550px] p-6 rounded-lg border border-zinc-300">
              <div className="flex">
                <img src={lineIcon} alt="" />
                <p className="w-44 text-black text-[20px] font-medium">
                  Patients summary
                </p>
              </div>

              <div className="flex bg-emerald-200 rounded-lg justify-between pl-8 pr-8 pt-2 pb-2 mt-4 items-center">
                <div className="flex items-center gap-4">
                  <p className="bg-emerald-600 rounded-lg w-11 h-8 pt-1 text-white text-center">
                    15
                  </p>
                  <p className="text-base font-normal">All patients</p>
                  <div className="w-2.5 h-2.5 bg-emerald-600 rounded-full" />
                </div>
                <div className="flex gap-4 items-center">
                  <p className="text-black text-base font-normal">
                    Manage patients
                  </p>
                  <span>
                    <img src={rightArrow} alt="" />
                  </span>
                </div>
              </div>

              <div className="flex gap-4 mt-4">
                <div className="w-36 h-20 pl-3.5 pr-20 pt-2 pb-3.5 rounded border border-zinc-300 flex-col justify-center items-start">
                  <p className="text-xl font-normal">25</p>
                  <p className="text-neutral-400 text-base font-normal">
                    Active
                  </p>
                </div>
                <div className="w-36 h-20 pl-3.5 pr-20 pt-2 pb-3.5 rounded border border-zinc-300 flex-col justify-center items-start">
                  <p className="text-xl font-normal">70</p>
                  <p className="text-neutral-400 text-base font-normal">
                    Inactive
                  </p>
                </div>
                <div className="w-36 h-20 pl-3.5 pr-20 pt-2 pb-3.5 rounded border border-zinc-300 flex-col justify-center items-start">
                  <p className="text-xl font-normal">5</p>
                  <p className="text-neutral-400 text-base font-normal">
                    Referred
                  </p>
                </div>
              </div>

              {/* charts and percentage */}
              <div className="flex">
                <div className="flex justify-around gap-8 items-center mt-4">
                  <div className="flex items-center justify-center w-[100%]">
                    <div className="w-[48%]">
                      <Doughnut data={doughnutData} />
                    </div>
                    <div>
                      <p>Active (15%)</p>
                      <p>Inactive (50%)</p>
                      <p>Referred (10%)</p>
                    </div>
                  </div>

                  <div>
                    <div className="flex items-center gap-6">
                      <div className=" inline-flex w-36 h-1 pr-10 bg-zinc-400 bg-opacity-25 rounded-3xl justify-start items-center">
                        <div className="w-24 h-1 relative bg-red-700 rounded-3xl" />
                      </div>
                      <span>25</span>
                    </div>

                    <div className="flex items-center gap-6">
                      <div className="w-36 h-1 pr-16 bg-zinc-400 bg-opacity-25 rounded-3xl justify-start items-center inline-flex">
                        <div className="w-20 h-1 relative bg-emerald-600 rounded-3xl" />
                      </div>
                      <span>70</span>
                    </div>

                    <div className="flex items-center gap-6">
                      <div className="w-36 h-1 pr-20 bg-zinc-400 bg-opacity-25 rounded-3xl justify-start items-center inline-flex">
                        <div className="w-14 h-1 relative bg-emerald-200 rounded-3xl" />
                      </div>
                      <span>5</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-[680px] p-6 rounded-lg border border-zinc-300">
              <div className="flex justify-between items-center">
                <div className="flex gap-2">
                  <img src={lineIcon} alt="" />
                  <p className="text-[20px] font-medium">Revenue</p>
                </div>

                <div className=" w-28 h-12 flex items-center justify-center gap-2 border border-zinc-300 rounded-2xl">
                  <p className="text-neutral-600 ">Monthly</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z"
                      fill="#B1B1B4"
                    />
                  </svg>
                </div>
              </div>

              <div className="flex justify-center items-center gap-12 text-neutral-600 font-euclid-circular-a">
                <div>
                  <p>Income</p>
                  <p className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M0 6.22222C0 5.7313 0.397969 5.33333 0.888889 5.33333H1C1.55228 5.33333 2 4.88562 2 4.33333V1.29308C2 0.578934 2.57893 0 3.29308 0C3.7336 0 4.1438 0.224257 4.38159 0.595077L6.54615 3.97061C7.09069 4.81978 8.03007 5.33333 9.03884 5.33333H9.33333C10.8061 5.33333 12 4.13943 12 2.66667V1C12 0.447716 12.4477 0 13 0C13.5523 0 14 0.447715 14 1V4.33333C14 4.88562 14.4477 5.33333 15 5.33333H15.1111C15.602 5.33333 16 5.7313 16 6.22222C16 6.71314 15.602 7.11111 15.1111 7.11111H14.8889C14.398 7.11111 14 7.50908 14 8C14 8.49092 14.398 8.88889 14.8889 8.88889H15.1111C15.602 8.88889 16 9.28686 16 9.77778C16 10.2687 15.602 10.6667 15.1111 10.6667H15C14.4477 10.6667 14 11.1144 14 11.6667V14.7062C14 15.4207 13.4207 16 12.7062 16C12.266 16 11.8561 15.7762 11.618 15.406L9.44285 12.0239C8.89883 11.178 7.96208 10.6667 6.95634 10.6667H6.66667C5.19391 10.6667 4 11.8606 4 13.3333V15C4 15.5523 3.55228 16 3 16C2.44772 16 2 15.5523 2 15V11.6667C2 11.1144 1.55228 10.6667 1 10.6667H0.888889C0.397969 10.6667 0 10.2687 0 9.77778C0 9.28686 0.397969 8.88889 0.888889 8.88889H1.11111C1.60203 8.88889 2 8.49092 2 8C2 7.50908 1.60203 7.11111 1.11111 7.11111H0.888889C0.397969 7.11111 0 6.71314 0 6.22222ZM4 4.93481C4 5.15491 4.17843 5.33333 4.39853 5.33333C4.71414 5.33333 4.90452 4.98391 4.73339 4.71872C4.51792 4.38481 4 4.53741 4 4.93481ZM4.88889 7.11111C4.39797 7.11111 4 7.50908 4 8C4 8.49092 4.39797 8.88889 4.88889 8.88889H5.79405C6.49685 8.88889 6.92169 8.11179 6.54231 7.52018C6.37885 7.26527 6.09687 7.11111 5.79405 7.11111H4.88889ZM11.2545 11.292C11.4739 11.6311 12 11.4757 12 11.0719C12 10.8481 11.8186 10.6667 11.5948 10.6667C11.2736 10.6667 11.0801 11.0224 11.2545 11.292ZM10.1937 7.11111C9.48926 7.11111 9.06472 7.89135 9.44731 8.48279C9.6111 8.736 9.89209 8.88889 10.1937 8.88889H11.1111C11.602 8.88889 12 8.49092 12 8C12 7.50908 11.602 7.11111 11.1111 7.11111H10.1937Z"
                        fill="#4F4F4F"
                      />
                    </svg>{" "}
                    115,000
                  </p>
                </div>
                <div>
                  <p>Expenses</p>
                  <p className="flex items-center gap-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M0 6.22222C0 5.7313 0.397969 5.33333 0.888889 5.33333H1C1.55228 5.33333 2 4.88562 2 4.33333V1.29308C2 0.578934 2.57893 0 3.29308 0C3.7336 0 4.1438 0.224257 4.38159 0.595077L6.54615 3.97061C7.09069 4.81978 8.03007 5.33333 9.03884 5.33333H9.33333C10.8061 5.33333 12 4.13943 12 2.66667V1C12 0.447716 12.4477 0 13 0C13.5523 0 14 0.447715 14 1V4.33333C14 4.88562 14.4477 5.33333 15 5.33333H15.1111C15.602 5.33333 16 5.7313 16 6.22222C16 6.71314 15.602 7.11111 15.1111 7.11111H14.8889C14.398 7.11111 14 7.50908 14 8C14 8.49092 14.398 8.88889 14.8889 8.88889H15.1111C15.602 8.88889 16 9.28686 16 9.77778C16 10.2687 15.602 10.6667 15.1111 10.6667H15C14.4477 10.6667 14 11.1144 14 11.6667V14.7062C14 15.4207 13.4207 16 12.7062 16C12.266 16 11.8561 15.7762 11.618 15.406L9.44285 12.0239C8.89883 11.178 7.96208 10.6667 6.95634 10.6667H6.66667C5.19391 10.6667 4 11.8606 4 13.3333V15C4 15.5523 3.55228 16 3 16C2.44772 16 2 15.5523 2 15V11.6667C2 11.1144 1.55228 10.6667 1 10.6667H0.888889C0.397969 10.6667 0 10.2687 0 9.77778C0 9.28686 0.397969 8.88889 0.888889 8.88889H1.11111C1.60203 8.88889 2 8.49092 2 8C2 7.50908 1.60203 7.11111 1.11111 7.11111H0.888889C0.397969 7.11111 0 6.71314 0 6.22222ZM4 4.93481C4 5.15491 4.17843 5.33333 4.39853 5.33333C4.71414 5.33333 4.90452 4.98391 4.73339 4.71872C4.51792 4.38481 4 4.53741 4 4.93481ZM4.88889 7.11111C4.39797 7.11111 4 7.50908 4 8C4 8.49092 4.39797 8.88889 4.88889 8.88889H5.79405C6.49685 8.88889 6.92169 8.11179 6.54231 7.52018C6.37885 7.26527 6.09687 7.11111 5.79405 7.11111H4.88889ZM11.2545 11.292C11.4739 11.6311 12 11.4757 12 11.0719C12 10.8481 11.8186 10.6667 11.5948 10.6667C11.2736 10.6667 11.0801 11.0224 11.2545 11.292ZM10.1937 7.11111C9.48926 7.11111 9.06472 7.89135 9.44731 8.48279C9.6111 8.736 9.89209 8.88889 10.1937 8.88889H11.1111C11.602 8.88889 12 8.49092 12 8C12 7.50908 11.602 7.11111 11.1111 7.11111H10.1937Z"
                        fill="#4F4F4F"
                      />
                    </svg>{" "}
                    75,000
                  </p>
                </div>
              </div>

              <div className="w-full mt-1 flex justify-center items-center">
                <Line options={areaOptions} data={areaData} />
              </div>
            </div>
          </div>

          {/* Inventory map and scheduled appointments */}
          <div className="flex gap-4 mt-16 ml-4">
            <div className="w-[500px] h-[400px] p-6 rounded-lg border border-zinc-300">
              <div className="flex justify-between items-center">
                <div className="flex gap-2">
                  <img src={lineIcon} alt="" />
                  <p className="text-[20px] font-medium">Inventory map</p>
                </div>

                <div className="flex items-center justify-center pl-2 gap-4 border border-zinc-300 rounded-2xl">
                  <p className="text-neutral-600 ">Monthly</p>
                  <p className="text-neutral-600 ">Weekly</p>
                  <div className="bg-black border border-black rounded-2xl">
                    <p className="text-white p-1">Today</p>
                  </div>
                </div>
              </div>

              <div className="p-4 mt-4 w-full">
                <Bar options={barOptions} data={barData} />
              </div>
            </div>

            <div className="w-[730px] h-[400px] p-6 rounded-lg border border-zinc-300">
              <div className="flex justify-between items-center">
                <div className="flex gap-2">
                  <img src={lineIcon} alt="" />
                  <p className="text-[20px] font-medium">
                    Scheduled appointments
                  </p>
                </div>

                <div className="flex items-center justify-center p-2 pl-2 gap-3 border border-zinc-300 rounded-2xl">
                  <p className="text-neutral-600 ml-2 font-medium">Newest</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z"
                      fill="#B1B1B4"
                    />
                  </svg>
                </div>
              </div>
              {appointmentData.map((data) => (
                <div
                  key={data.id}
                  className="w-full font-euclid-circular-a mt-4 rounded-lg border border-zinc-300 p-3 flex gap-9 items-center"
                >
                  <p className="font-semibold">{data.name}</p>
                  <div className="flex flex-col gap-2">
                    <p className="text-sky-500">{data.apptNo}</p>
                    <p className="font-light text-neutral-600">{data.date}</p>
                  </div>
                  <p className="font-semibold">{data.apptType}</p>
                  <div
                    className={
                      data.status === "Pending"
                        ? " p-2 w-24 flex items-center justify-center bg-amber-500 text-amber-500 bg-opacity-30 rounded-lg border border-amber-500"
                        : "p-2 w-24 flex items-center justify-center bg-emerald-200 text-emerald-600 rounded-lg border border-emerald-600"
                    }
                  >
                    {data.status}
                  </div>

                  <div ref={dropdownRef} className="dot">
                    <button onClick={() => toggleDropdown(data.id)}>
                      <span>
                        <HiOutlineDotsVertical />
                      </span>
                    </button>
                    {data.isOpen && (
                      <div className="dot_body">
                        <p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M14.25 8.74998C13.75 11.25 11.865 13.604 9.21998 14.13C7.92997 14.3869 6.59179 14.2303 5.39598 13.6824C4.20018 13.1345 3.2077 12.2233 2.55988 11.0786C1.91205 9.93383 1.6419 8.61387 1.78789 7.30666C1.93388 5.99944 2.48857 4.77161 3.37298 3.79798C5.18698 1.79998 8.24998 1.24998 10.75 2.24998"
                              stroke="#049561"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.75 7.75L8.25 10.25L14.25 3.75"
                              stroke="#049561"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          Completed
                        </p>
                        <p>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M8 9.12L10.32 11.44C10.4667 11.5867 10.6533 11.66 10.88 11.66C11.1067 11.66 11.2933 11.5867 11.44 11.44C11.5867 11.2933 11.66 11.1067 11.66 10.88C11.66 10.6533 11.5867 10.4667 11.44 10.32L9.12 8L11.44 5.68C11.5867 5.53333 11.66 5.34667 11.66 5.12C11.66 4.89333 11.5867 4.70667 11.44 4.56C11.2933 4.41333 11.1067 4.34 10.88 4.34C10.6533 4.34 10.4667 4.41333 10.32 4.56L8 6.88L5.68 4.56C5.53333 4.41333 5.34667 4.34 5.12 4.34C4.89333 4.34 4.70667 4.41333 4.56 4.56C4.41333 4.70667 4.34 4.89333 4.34 5.12C4.34 5.34667 4.41333 5.53333 4.56 5.68L6.88 8L4.56 10.32C4.41333 10.4667 4.34 10.6533 4.34 10.88C4.34 11.1067 4.41333 11.2933 4.56 11.44C4.70667 11.5867 4.89333 11.66 5.12 11.66C5.34667 11.66 5.53333 11.5867 5.68 11.44L8 9.12ZM8 16C6.89333 16 5.85333 15.7899 4.88 15.3696C3.90667 14.9493 3.06 14.3795 2.34 13.66C1.62 12.94 1.05013 12.0933 0.6304 11.12C0.210667 10.1467 0.000533333 9.10667 0 8C0 6.89333 0.210133 5.85333 0.6304 4.88C1.05067 3.90667 1.62053 3.06 2.34 2.34C3.06 1.62 3.90667 1.05013 4.88 0.6304C5.85333 0.210667 6.89333 0.000533333 8 0C9.10667 0 10.1467 0.210133 11.12 0.6304C12.0933 1.05067 12.94 1.62053 13.66 2.34C14.38 3.06 14.9501 3.90667 15.3704 4.88C15.7907 5.85333 16.0005 6.89333 16 8C16 9.10667 15.7899 10.1467 15.3696 11.12C14.9493 12.0933 14.3795 12.94 13.66 13.66C12.94 14.38 12.0933 14.9501 11.12 15.3704C10.1467 15.7907 9.10667 16.0005 8 16ZM8 14.4C9.78667 14.4 11.3 13.78 12.54 12.54C13.78 11.3 14.4 9.78667 14.4 8C14.4 6.21333 13.78 4.7 12.54 3.46C11.3 2.22 9.78667 1.6 8 1.6C6.21333 1.6 4.7 2.22 3.46 3.46C2.22 4.7 1.6 6.21333 1.6 8C1.6 9.78667 2.22 11.3 3.46 12.54C4.7 13.78 6.21333 14.4 8 14.4Z"
                              fill="#AF290B"
                            />
                          </svg>
                          Delete
                        </p>

                        <p>
                          <div className="border border-gray-500 rounded-full p-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="4"
                              height="8"
                              viewBox="0 0 4 8"
                              fill="none"
                            >
                              <path
                                d="M2.5 7V3H0.5V4H1.5V7H0V8H4V7H2.5ZM2 0C1.85166 0 1.70666 0.0439866 1.58332 0.126398C1.45999 0.208809 1.36386 0.325943 1.30709 0.462987C1.25032 0.600032 1.23547 0.750832 1.26441 0.896318C1.29335 1.0418 1.36478 1.17544 1.46967 1.28033C1.57456 1.38522 1.7082 1.45665 1.85368 1.48559C1.99917 1.51453 2.14997 1.49968 2.28701 1.44291C2.42406 1.38614 2.54119 1.29001 2.6236 1.16668C2.70601 1.04334 2.75 0.898336 2.75 0.75C2.75 0.551088 2.67098 0.360322 2.53033 0.21967C2.38968 0.0790175 2.19891 0 2 0Z"
                                fill="#4F4F4F"
                              />
                            </svg>{" "}
                          </div>
                          View Details
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
